import Layout from "../layouts/LayoutDefault.jsx";
import React, { useState, useEffect } from "react";
import MainContainer from "../components/MainContainer.jsx";
import ContentContainer from "../components/ContentContainer.jsx";

const gdprPage = () => {
  const apiUrl = import.meta.env.VITE_API_URL_TEXTS;

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(apiUrl + "lokultinfo");

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        setData(result);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <Layout
      title="Data hantering & GDPR"
      description="Så här hanterar vi din data på Lokult"
    >
      <MainContainer>
        <ContentContainer>
          <div className="m-auto max-w-2xl my-20">
            {data ? (
              <div
                className="prose lg:prose-xl prose-headings:text-base-content"
                dangerouslySetInnerHTML={{
                  __html: data.data.gdpr,
                }}
              />
            ) : (
              <p>No data available.</p>
            )}
          </div>
        </ContentContainer>
      </MainContainer>
    </Layout>
  );
};

export default gdprPage;
